export default {
    PROCCESS_RES: (state, data) => {
        const { type } = data;

        state[type].items = data.items;

        state[type].pagination = {
            page: data.page || 1,
            totalPages: data.totalPages || 1
        };
    },

    SET_TARIFFS_BRAND_ID: (state, brandId) => {
        state.tariffs.filters.brandId = brandId;
    },

    SET_TARIFFS_OPTION_NAME: (state, optionName) => {
        state.tariffs.filters.optionName = optionName;
    },

    SET_TARIFFS_OPTION_CLASS_ID: (state, optionClassId) => {
        state.tariffs.filters.optionClassId = optionClassId;
    },

    SET_COMMISSIONS_BRAND_ID: (state, brandId) => {
        state.commissions.filters.brandId = brandId;
    },

    SET_COMMISSIONS_STATUS: (state, status) => {
        state.commissions.filters.status = status;
    },

    SET_COMMISSIONS_TITLE: (state, title) => {
        state.commissions.filters.title = title;
    },

    SET_COMMISSION_SYSTEMS_BRAND_ID: (state, brandId) => {
        state.commissionSystems.filters.brandId = brandId;
    },

    SET_COMMISSION_SYSTEMS_NAME: (state, name) => {
        state.commissionSystems.filters.name = name;
    },

    SET_PENALTIES_BRAND_ID: (state, brandId) => {
        state.penalties.filters.brandId = brandId;
    },

    SET_PENALTIES_TITLE: (state, title) => {
        state.penalties.filters.title = title;
    },

    ADD_OPTION: (state, { optionId, ...data }) => {
        const oldOptionIndex = state.tariffs.items.findIndex(
            option => option.id == optionId
        );

        if (oldOptionIndex !== -1) {
            // Insert before selected option
            state.tariffs.items.splice(oldOptionIndex + 1, 0, data);
        }
    }
};
